const spamList = [
  '0x6b021dbd1b47962780eb2de55eef1aabc932affcef50581f63b431119334781c',
];

export default spamList;
